import ReactDOM from "react-dom";
import { App } from "./App";
import "./index.css";

const app = document.querySelector("#app");
ReactDOM.render(<App />, app);
